<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="tipodivision">
    <fieldset id="agregar_tipodivision" class="">
        <div class="step_section">
            <div class="row" id="row">
                <form [formGroup]="form">
                    <div class="col-md-12" id="content">
                        <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                            <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                            <span id="tp_dir_message"></span>
                        </div>
                        <div class="form-horizontal titulo">
                            <div class="form-group" align="left">
                                <div class="col-md-2">
                                    <label for="tipoaprob">Permiso de urbanizaci&oacute;n</label>
                                </div>
                                <div class="col-sm-10" class="inline" style="font-size: 13px">
                                    <div class="col-md-3">
                                        <mat-checkbox formControlName="permiso_urb1" name="permiso_urb1" value="SI" (change)="add_permiso_urb()">Vialidad</mat-checkbox>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-checkbox formControlName="permiso_urb2" name="permiso_urb2" value="SI" (change)="add_permiso_urb()">Otros</mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                </form>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>